import { Action } from '@/_core/fluxstore/types';
import { StorymapState } from '../types';
import { useStorymapStore } from '../useModule';
import { getCardById } from '../use';

const { registerReducer } = useStorymapStore();

export class UpdateCardDescription extends Action<StorymapState> {
    public static ACTION_TYPE = 'UpdateCardDescription';

    public constructor(public cardId: string, public description: string) {
        super(UpdateCardDescription.ACTION_TYPE);
    }
}

const reducer = (state: StorymapState, action: UpdateCardDescription): void => {
    const card = getCardById(action.cardId);

    if (card) {
        card.description = action.description;
        // Dispatched with the full description loaded by card details; a later preload must not replace it (R18).
        card.isFullDescriptionLoaded = true;
    }
};

//@ts-ignore
registerReducer(UpdateCardDescription.ACTION_TYPE, reducer);
